import { API_URL_CEP } from '@/commons/config';
import Axios from 'axios-observable';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

export class CepAPI {
  protected axios: Axios;
  protected url: string;

  constructor() {
    this.settingsInstance()
  }

  public find(cep: string): AxiosObservable<any> {
    return this.axios.get(`${this.url}/${cep}/json`)
  }

  private settingsInstance() {
    this.url = API_URL_CEP
    this.axios = Axios.create({})
  }
}
